import store from '../services/store';
let merchantRoutes;
if (
  store &&
  store.getters.currentMerchantObject &&
  store.getters.currentMerchantObject.categoryTypes &&
  store.getters.currentMerchantObject.categoryTypes.length
) {
  merchantRoutes = [
    {
      name: 'خدمات و محصولات',
      link: '/supplier-products',
      icon: 'fas fa-th-list',
      root: false,
      childs: [
        {
          name: 'حوزه های فعالیت من',
          link: '/supplier-products/my-activity',
          icon: 'mdi mdi-web',
          root: true,
          childs: [],
        },
      ],
    },
  ];
  store.getters.currentMerchantObject.categoryTypes.forEach((type) => {
    if (type == 'Product') {
      merchantRoutes[0]['childs'].push({
        name: 'محصولات و کالا',
        link: '/supplier-products/Product',
        icon: 'fab fa-product-hunt',
        root: true,
        childs: [],
      });
    } else if (type == 'IndustrialService') {
      merchantRoutes[0]['childs'].push({
        name: 'خدمات ساخت و تولید',
        link: '/supplier-products/IndustrialService',
        icon: 'fas fa-tools',
        root: true,
        childs: [],
      });
    } else if (type == 'ConsultingService') {
      merchantRoutes[0]['childs'].push({
        name: 'خدمات طراحی، مهندسی و مشاوره',
        link: '/supplier-products/ConsultingService',
        icon: 'mdi mdi-account-tie',
        root: true,
        childs: [],
      });
    } else if (type == 'ElectronicDocument') {
      merchantRoutes[0]['childs'].push({
        name: 'استانداردها و خدمات آموزشی',
        link: '/supplier-products/ElectronicDocument',
        icon: 'fas fa-book-open',
        root: true,
        childs: [],
      });
    }
  });
}

export const merchantMenu = [
  {
    name: 'اطلاعات کسب و کار',
    link: '/business-information',
    icon: 'mdi mdi-note-plus-outline',
    root: true,
  },
  {
    name: 'درخواست مناقصه/استعلام',
    link: '/trade-request',
    icon: 'fas fa-plus-square',
    root: true,
  },
    {
    name: 'سفارش مستقیم کالا/خدمات',
    link: '/trade-request-direct',
    icon: 'fas fa-plus-square',
    root: true,
  },
  {
    name: 'بارگذاری مدارک',
    link: '/upload-documents',
    icon: 'mdi mdi-briefcase-upload-outline',
    root: true,
  },
  {
    name: 'مدیریت مالی',
    link: '/financial-management',
    icon: 'mdi mdi-cash',
    root: false,
    childs: [
      {
        root: true,
        name: 'محاسبات شارژ اعتبار',
        link: '/financial-management/service-prices',
        icon: 'mdi mdi-wallet',
      },
      {
        root: true,
        name: ' کیف پول اعتباری',
        link: '/financial-management/wallet',
        icon: 'mdi mdi-wallet-plus',
      },
       {
        name: 'مدیریت حق اشتراک',
        link: '/financial-management/subscription',
        icon: 'mdi mdi-account-edit',
        root: true,
      },
    ],
  },
  {
    external: true,
    name: 'بازگشت به سایت اصلی',
    link: store.getters.taksaanUrl,
    icon: 'mdi mdi-flash',
    root: true,
  },
  {
    external: true,
    name: ' پروفایل کاربر',
    link:
      store.getters.authBaseUrl +
      '?ReturnUrl=' +
      store.getters.uiExternalUrl +
      '&AppTitle=پنل تامین کننده',
    icon: 'mdi mdi-account-outline',
    root: true,
  },
  {
    exit: true,
    name: 'خروج',
    link: '',
    icon: 'mdi mdi-close',
    root: true,
  },
];
export const merchantAsConsumerMenu = [
  {
    name: 'اطلاعات خریدار',
    link: '/business-information',
    icon: 'mdi mdi-note-plus-outline',
    root: true,
  },
  {
    name: 'درخواست مناقصه/استعلام',
    link: '/trade-request',
    icon: 'fas fa-plus-square',
    root: true,
  },
    {
    name: 'سفارش مستقیم کالا/خدمات',
    link: '/trade-request-direct',
    icon: 'fas fa-plus-square',
    root: true,
  },
  {
    name: 'تغییر وضعیت به تامین کننده',
    link: '/change-to-business',
    icon: 'mdi mdi-note-plus-outline',
    root: true,
  },
  {
    name: 'بارگذاری مدارک',
    link: '/upload-documents',
    icon: 'mdi mdi-briefcase-upload-outline',
    root: true,
  },
  {
    name: 'مدیریت مالی',
    link: '/financial-management',
    icon: 'mdi mdi-cash',
    root: false,
    childs: [
      {
        root: true,
        name: 'محاسبات شارژ اعتبار',
        link: '/financial-management/service-prices',
        icon: 'mdi mdi-wallet',
      },
      {
        root: true,
        name: ' کیف پول اعتباری',
        link: '/financial-management/wallet',
        icon: 'mdi mdi-wallet-plus',
      },
       {
        name: 'مدیریت حق اشتراک',
        link: '/financial-management/subscription',
        icon: 'mdi mdi-account-edit',
        root: true,
      },
    ],
  },
  {
    external: true,
    name: 'بازگشت به سایت اصلی',
    link: store.getters.taksaanUrl,
    icon: 'mdi mdi-flash',
    root: true,
  },
  {
    external: true,
    name: ' پروفایل کاربر',
    link:
      store.getters.authBaseUrl +
      '?ReturnUrl=' +
      store.getters.uiExternalUrl +
      '&AppTitle=پنل تامین کننده',
    icon: 'mdi mdi-account-outline',
    root: true,
  },
  {
    exit: true,
    name: 'خروج',
    link: '',
    icon: 'mdi mdi-close',
    root: true,
  },
];
export const supplierMenu = [
  {
    name: 'داشبورد',
    link: '/dashboard',
    icon: 'mdi mdi-view-dashboard',
    root: true,
    childs: [],
  },
  {
    name: 'مدیریت محتوا',
    link: '/contents',
    icon: 'flaticon-questions-circular-button',
    root: false,
    childs: [
      {
        name: 'مدیریت صفحات',
        link: '/contents/pages',
        icon: 'flaticon-file-2',
        root: true,
      },
      {
        name: 'مدیریت سوالات متداول',
        link: '/contents/faq',
        icon: 'flaticon-support',
        root: true,
      },
    ],
  },
  {
    name: 'درخواست مناقصه/استعلام',
    link: '/trade-request',
    icon: 'fas fa-plus-square',
    root: true,
  },
    {
    name: 'سفارش مستقیم کالا/خدمات',
    link: '/trade-request-direct',
    icon: 'fas fa-plus-square',
    root: true,
  },
  {
    name: 'مدیریت تقاضا',
    link: '/trade-response',
    icon: 'mdi mdi-frequently-asked-questions',
    root: true,
  },
  {
    name: 'اطلاعات کسب و کار من',
    link: '/business-information',
    icon: 'mdi mdi-note-plus-outline',
    root: true,
  },
  {
    external: true,
    name: 'مشاهده کسب و کار در وب سایت',
    link:
      store &&
      store.getters.currentMerchantObject &&
      store.getters.currentMerchantObject.name
        ? store.getters.taksaanUrl +
          '/supplier/' +
          store.getters.currentMerchant +
          '/' +
          store.getters.currentMerchantObject.name
            .replace(/\s+/g, '-')
            .toLowerCase() +
          '?panel=supplier'
        : '',
    icon: 'mdi mdi-web',
    root: true,
  },
  {
    name: 'کسب و کارهای من',
    link: '/merchant-companies/list',
    icon: 'mdi mdi-notebook-outline',
    root: true,
  },
  {
    name: 'نمایندگی های من',
    link: '/merchant-delegations',
    icon: 'far fa-building',
    root: true,
  },
  {
    name: 'بارگذاری مدارک',
    link: '/upload-documents',
    icon: 'mdi mdi-briefcase-upload-outline',
    root: true,
  },
  {
    name: 'پشتیبانی',
    link: store.getters.crmExtrnalUrl,
    icon: 'flaticon-support',
    root: true,
    external: true,
  },
  {
    name: 'مدیریت مالی',
    link: '/financial-management',
    icon: 'mdi mdi-cash',
    root: false,
    childs: [
      {
        root: true,
        name: 'محاسبات شارژ اعتبار',
        link: '/financial-management/service-prices',
        icon: 'mdi mdi-wallet',
      },
      {
        root: true,
        name: ' کیف پول اعتباری',
        link: '/financial-management/wallet',
        icon: 'mdi mdi-wallet-plus',
      },
      {
        name: 'مدیریت حق اشتراک',
        link: '/financial-management/subscription',
        icon: 'mdi mdi-account-edit',
        root: true,
      },
    ],
  },
  {
    external: true,
    name: 'بازگشت به سایت اصلی',
    link: store.getters.taksaanUrl,
    icon: 'mdi mdi-flash',
    root: true,
  },
  {
    external: true,
    name: 'پروفایل کاربر',
    link:
      store.getters.authBaseUrl +
      '?ReturnUrl=' +
      store.getters.uiExternalUrl +
      '&AppTitle=پنل تامین کننده',
    icon: 'mdi mdi-account-outline',
    root: true,
  },
  {
    exit: true,
    name: 'خروج',
    link: '',
    icon: 'mdi mdi-close',
    root: true,
  },
];
if (merchantRoutes) {
  supplierMenu.splice(7, 0, ...merchantRoutes);
}
